import {getConfigWithAuth} from "./APIReqHelper";
import apiClient from "./apiClient"
import paymentAPIClient from "./paymentAPIClient";
import reportAPIClient from "./reportAPIClient";
import shipdayApiClient from "./shipdayApiClient";
import realTimeClient from "./realTimeClient";
import aiClient from "./aiClient";

export const getJSON = (url, params = {}) => {
    return apiClient.get(url, {
        params: params,
        headers: getConfigWithAuth().headers,
    });
}

export const getJSONWithoutAuth = (url, params = {}) => {
    return apiClient.get(url, {
        params: params,
    });
}

export const postJSON = (url, data, withAuth = false) => {
    if (withAuth) return apiClient.post(url, data, getConfigWithAuth());
    return apiClient.post(url, data);
}

export const deleteJSON = (url) => {
    return apiClient.delete(url, getConfigWithAuth());
}

export const putJSON = (url, data) => {
    return apiClient.put(url, data, getConfigWithAuth())
}

export const paymentPostJSON = (url, data) => {
    return paymentAPIClient.post(url, data, getConfigWithAuth());
}

export const paymentGetJSON = (url) => {
    return paymentAPIClient.get(url, getConfigWithAuth());
}

export const paymentPutJSON = (url, data) => {
    return paymentAPIClient.put(url, data, getConfigWithAuth());
}

export const paymentDelJSON = (url) => {
    return paymentAPIClient.delete(url, getConfigWithAuth());
}

export const reportGetJSON = (url, params) => {
    return reportAPIClient.get(url, {
        params: params,
        headers: getConfigWithAuth().headers
    });
}

export const shipdayGetJSON = (url, params) => {
    return shipdayApiClient.get(url, {params: params});
}

export const shipdayPostJSON = (url, data) => {
    return shipdayApiClient.post(url, data, getConfigWithAuth());
};

export const realTimePost = (url, data) => {
    return realTimeClient.post(url, data, getConfigWithAuth());
};

export const aiPostJSON = (url, data) => {
    return aiClient.post(url, data, getConfigWithAuth());
};
